import { keyframes } from '@emotion/react'
import { HStack } from '~/design_system'
import { SingleSparkle } from '~/assistant/icons'

const sparkleAnimation = keyframes`
  0%, 66.67%, 100% {
    transform: scale(0.8);
    opacity: 0.3;
  }
  33.33% {
    transform: scale(1.5);
    opacity: 1;
  }
`

const ANIMATION_DELAYS = ['0s', '0.75s', '1.5s']

type SparkleSpinnerProps = {
  size?: number
  color?: string
}

export const SparkleSpinner = ({ size = 4, color = 'blue.500' }: SparkleSpinnerProps) => (
  <HStack spacing={2}>
    {ANIMATION_DELAYS.map(delay => (
      <SingleSparkle
        key={delay}
        boxSize={size}
        color={color}
        sx={{ animation: `${sparkleAnimation} 2.25s infinite`, animationDelay: delay }}
      />
    ))}
  </HStack>
)
